import {internalApi} from "../../../common/axios";
import {useQueryBase} from "../../../shared/hooks/useHookBase";
import toast from "react-hot-toast";

const fetchPassMasterData = async (passType) => {
    const {data} = await internalApi.get(`pass_master/${passType}`);
    return data.rows;
}

export const usePassMasterData = (passType) => {
    return useQueryBase(['passMasterData', passType], () => fetchPassMasterData(passType), {staleTime: 0});
}

export const savePassMaster = async (data) => {
    try {
        const res = await internalApi.post('pass_master', {data});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const deletePassMaster = async (seq) => {
    try {
        const res = await internalApi.delete(`pass_master/${seq}`);
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("삭제 실패");
    }
}
